module.exports = __webpack_public_path__ + "img/keyboard-controls.d276cd09.svg";